import { useEffect } from 'react'
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'
import { AudioControls } from '../components/AudioControls'
import { CustomDragLayer } from '../components/CustomDragLayer'
import { GameHUD } from '../components/GameHUD'
import { GameScenario } from '../components/GameScenario'
import MenuButton from '../components/MenuButton'
import TrashItem from '../components/TrashItem'
import { Truck } from '../components/Truck'
import { isTouchDevice, useGame } from '../contexts/GameContext'
import { useAudio } from '../hooks/useAudio'
import { cn } from '../lib/utils'

const backendOptions = {
	enableMouseEvents: true,
	delayTouchStart: 200,
	delayMouseStart: 0,
	touchSlop: 5,
}

export function GameScreen() {
	const { currentScreen, trashItems, changeScreen } = useGame()
	const { startMusic, stopMusic } = useAudio()

	useEffect(() => {
		if (currentScreen === 'game') {
			startMusic()
		} else {
			stopMusic()
		}
	}, [currentScreen, startMusic, stopMusic])

	return (
		<div
			className={cn(
				'pointer-events-none absolute inset-0 opacity-0 transition-opacity duration-300',
				{ 'game-screen pointer-events-auto opacity-100': currentScreen === 'game' }
			)}
		>
			<DndProvider
				backend={isTouchDevice() ? TouchBackend : HTML5Backend}
				options={isTouchDevice() ? backendOptions : {}}
			>
				<div className="relative h-dvh w-dvw overflow-hidden">
					<GameScenario />

					{trashItems.map((item) => (
						<TrashItem key={item.id} {...item} />
					))}

					<MenuButton
						src="./assets/botoes/botao_fechar.svg"
						alt="Fechar"
						onClick={() => changeScreen('home')}
						title="Voltar para Home"
						className="absolute top-5 right-5 size-10"
					/>

					<GameHUD />

					<Truck />

					<AudioControls />

					<CustomDragLayer />
				</div>
			</DndProvider>
		</div>
	)
}
